import { Actions, ActionTypes } from './actions';
import { notificationTemplateAdapter, initialState, NotificationTemplateState } from './state';

export function notificationTemplateReducer(state = initialState, action: Actions): NotificationTemplateState {
  switch (action.type) {
    case ActionTypes.FAILURE: {
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };
    }

    case ActionTypes.LOAD_REQUEST:
    case ActionTypes.SAVE_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    }

    case ActionTypes.LOAD_SUCCESS: {
      return notificationTemplateAdapter.upsertMany(action.templates, {
        ...state,
        isLoading: false,
        error: null,
      });
    }

    case ActionTypes.SAVE_SUCCESS: {
      return notificationTemplateAdapter.upsertOne(action.template, {
        ...state,
        selected: { ...action.template },
        isLoading: false,
        error: null,
      });
    }

    case ActionTypes.LOAD_PARAMETERS_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    }

    case ActionTypes.LOAD_PARAMETERS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        error: null,
        parameters: [...action.parameters],
      };
    }

    default: {
      return state;
    }
  }
}
